{
  "pt": {
    "login": {
      "acceptTos": "termos e condições",
      "acceptTosPrefix": "Aceito os ",
      "acceptTosRequired": "Deve aceitar os termos e condições para criar uma conta.",
      "auth-ziggu/invalid-invitation-code": "Verifique junto da pessoa que partilhou o link se está disponível um novo. Se já existir uma conta, inicie sessão em vez disso.",
      "auth-ziggu/user-created": "A sua conta de utilizador foi criada! 🎉 A iniciar sessão, aguarde..",
      "auth/invalid-action-code": "Por motivos de segurança, os links de redefinição de palavra-passe expiram ao fim de algum tempo. Se ainda for necessário redefinir a palavra-passe, pode solicitar um novo e-mail de redefinição.",
      "auth/invalid-credential": "A palavra-passe é inválida para o e-mail fornecido, ou não existe uma conta para este e-mail.",
      "auth/invalid-email": "O endereço de e-mail não é válido.",
      "auth/network-request-failed": "Ocorreu um erro de rede. Verifique a sua conexão e tente novamente.",
      "auth/too-many-requests": "Muitas solicitações. Tente novamente mais tarde.",
      "backToLogin": "Voltar ao login",
      "cookiePolicy": "Política de Cookies",
      "emailAddress": "Endereço de e-mail",
      "emailAddressInvalid": "Introduza um endereço de e-mail válido",
      "emailAddressRequired": "Endereço de e-mail é obrigatório",
      "googleLogin": "Entrar com Google",
      "notification_error_no_access": "A sua conta não tem acesso.",
      "notification_error_session_expired": "A sessão expirou, inicie sessão novamente.",
      "notification_success_logout": "Saiu da sua conta.",
      "notification_success_profile_transfer": "O seu endereço de e-mail foi alterado. Inicie sessão com o novo endereço de e-mail e a respetiva palavra-passe.",
      "password": "Palavra-passe",
      "passwordConfirmMatchRequired": "A confirmação da palavra-passe não corresponde",
      "passwordConfirmRequired": "Confirmação da palavra-passe é obrigatória",
      "passwordForgot": "Esqueceu-se da sua palavra-passe?",
      "passwordLengthRequired": "A palavra-passe deve conter pelo menos 8 caracteres",
      "passwordRequired": "Palavra-passe é obrigatória",
      "password_confirm": "Confirmação da palavra-passe",
      "privacyPolicy": "Política de Privacidade",
      "submit_expired_reset": "Solicitar uma nova redefinição de palavra-passe",
      "submit_expired_signup": "Voltar ao login",
      "submit_login": "Entrar",
      "submit_password_forgot": "Solicitar redefinição de palavra-passe",
      "submit_password_reset": "Repor palavra-passe",
      "submit_signup": "Criar conta",
      "success_password_forgot": "Se tiver uma conta ativa, foi enviado um e-mail de redefinição de palavra-passe para {email}. Verifique a sua caixa de entrada de e-mail, o link de redefinição de palavra-passe expira em 1 hora.",
      "success_password_reset": "Redefinição de palavra-passe bem-sucedida, a iniciar sessão agora...",
      "termsandconditionsPolicy": "Termos e Condições",
      "title_expired_reset": "Ops, esse é um link expirado..",
      "title_expired_signup": "Este link de convite não está mais ativo",
      "title_login": "Bem-vindo de volta!",
      "title_password_forgot": "Esqueceu-se da sua palavra-passe?",
      "title_password_reset": "Redefina a sua palavra-passe",
      "title_signup": "Conclua o registo"
    }
  }
}
